import React from "react";
import FormField from "../../Common/FormField";
import PEPSelectField from "../../Common/PEPSelectField";
import {Checkbox, SelectOption, Alert} from "@americanexpress/dls-react";
import {useTranslation} from "react-i18next";
import {GET_PEP_POSITION_LIST} from "../../Common/constants";
import "./PoliticallyExposedPerson.css";
import { useUniqueId } from "../../../hooks/useUniqueId";

const PoliticallyExposedPerson = ({ formik }) => {

    const { t } = useTranslation("common");
    const PEP_POSITION_LIST = GET_PEP_POSITION_LIST(t);
    const baseId = useUniqueId("pep-section");

    const handleCheckboxChange = (event) => {
        const {name, checked} = event.target;
        const nextIsPep = checked && name === "politicallyExposedPerson";
        const nextIsFamily = checked && name === "familyOfPoliticallyExposedPerson";
        const nextValues = {
            ...formik.values,
            notPoliticallyExposedPerson: checked && name === "notPoliticallyExposedPerson",
            familyOfPoliticallyExposedPerson: nextIsFamily,
            politicallyExposedPerson: nextIsPep,
        };
        formik.setValues(nextValues, true);
        formik.setFieldTouched("notPoliticallyExposedPerson", true, false);
        if (nextIsPep || nextIsFamily) {
            formik.setFieldTouched("politicallyExposedPersonDropdown", true, false);
            formik.setFieldTouched("pepTitle", true, false);
            formik.setFieldTouched("pepCountry", true, false);
            formik.setFieldTouched("pepOrganization", true, false);
        }
    };
    const pepSelectionError =
        formik.touched.notPoliticallyExposedPerson &&
        formik.errors.notPoliticallyExposedPerson;

    return (
        <section id="politically-exposed-person-info">
            <div className="row">
                <div className="col-xs-12">
                    <h4 className="heading-4 dls-deep-blue pad-2-t pad-2-b">
                        {t("newuser.politicallyExposedHeader")}
                    </h4>
                </div>
            </div>
            <p>
                {t("newuser.areYouApoliticallyExposedPerson")}
            </p>
            <Checkbox
                id={`${baseId}-notPoliticallyExposedPerson`}
                name="notPoliticallyExposedPerson"
                label={t("newuser.notPoliticallyExposedPerson")}
                checked={formik.values.notPoliticallyExposedPerson}
                onChange={handleCheckboxChange}
            />
            <Checkbox
                id={`${baseId}-familyOfPoliticallyExposedPerson`}
                name="familyOfPoliticallyExposedPerson"
                label={t("newuser.familyOfPoliticallyExposedPerson")}
                checked={formik.values.familyOfPoliticallyExposedPerson}
                onChange={handleCheckboxChange}
            />
            <Checkbox
                id={`${baseId}-politicallyExposedPerson`}
                name="politicallyExposedPerson"
                label={t("newuser.politicallyExposedPerson")}
                checked={formik.values.politicallyExposedPerson}
                onChange={handleCheckboxChange}
            />
            {pepSelectionError && (
                <Alert id="pep-selection-error" status="error">
                    {pepSelectionError}
                </Alert>
            )}
            <div className="row pad-1-t">
                <PEPSelectField
                    className="dropdownMaxContent"
                    id="politicallyExposedPersonDropdown"
                    name="politicallyExposedPersonDropdown"
                    label={t("newuser.politicallyExposedPosition")}
                    header={t("newuser.politicallyExposedPersonInfo")}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    value={formik.values.politicallyExposedPersonDropdown}
                    error={formik.touched.politicallyExposedPersonDropdown && formik.errors.politicallyExposedPersonDropdown}
                >
                    {PEP_POSITION_LIST.map(({label, value}) => (
                        <SelectOption key={value} value={value} data-label={value}>
                            {label}
                        </SelectOption>
                    ))}
                </PEPSelectField>
            </div>
            <div className="row">
                <FormField
                    id="pepTitle"
                    name="pepTitle"
                    label={t("newuser.politicallyExposedTitle")}
                    value={formik.values.pepTitle}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.pepTitle && formik.errors.pepTitle}
                />
                <FormField
                    id="pepCountry"
                    name="pepCountry"
                    label={t("newuser.politicallyExposedCountry")}
                    value={formik.values.pepCountry}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.pepCountry && formik.errors.pepCountry}
                />
                <FormField
                    id="pepOrganization"
                    name="pepOrganization"
                    label={t("newuser.politicallyExposedOrganization")}
                    value={formik.values.pepOrganization}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.pepOrganization && formik.errors.pepOrganization}
                />
            </div>
        </section>
    );
};

export default PoliticallyExposedPerson;
